import { Component } from '@angular/core';
import { MessagingService } from "./shared/messaging.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  message;
  title = 'socio';
  constructor(private messagingService: MessagingService) { }

  ngOnInit() {
  ///  let userId = 'user001';
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
  }
}
